import type {
  GetRecentlyViewedGoodsParams,
  GetRecentlyViewedGoodsResponse,
} from './types';
import { defaultHttpClient } from '../httpClient/HttpClient';

/**
 * - 최근 본 상품 조회 api
 * - 20개씩 pagination된다.
 */

export const getRecentlyViewedGoods = ({
  last_sno,
}: GetRecentlyViewedGoodsParams = {}) => {
  return defaultHttpClient.request<GetRecentlyViewedGoodsResponse>({
    method: 'GET',
    url: '/api/v2/members/me/recently_viewed_goods/?screen=RECENTLY_VIEWED_GOODS',
    params: {
      last_sno,
    },
  });
};
